<template>
  <h3 class="text-left mb-6 mt-1">{{ $t(title) }}</h3>
</template>

<script>
export default {
  name: "Title",
  mounted() {
    this.updateTitle();
  },
  updated() {
    this.updateTitle();
  },
  watch: {
    "$store.state.sectionTitle": {
      handler: function() {
        this.updateTitle();
      },
      deep: true,
      immediate: true
    }
  },
  data: () => ({
    title: ""
  }),
  methods: {
    updateTitle() {
      this.title = this.$store.state.sectionTitle;
    }
  }
};
</script>

<style scoped></style>
